import React from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';
import { ProductRelease } from '../../lib/productUpdates';
import EmptyState from '../ui/EmptyState';
import Modal from '../ui/Modal';
import Button from '../ui/Button';
import ReleaseNotes from './ReleaseNotes';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onFeedback: () => void;
  releases: ProductRelease[];
}

// Only the latest release is shown; older ones are not listed.
export default function WhatsNewDialog({ isOpen, onClose, onFeedback, releases }: Props) {
  const latest = releases[0];
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      // No header: the dateline opens the dialog; Escape, the backdrop and "Got it" close it.
      ariaLabel="What’s new in Vein"
      hideCloseButton
      size="md"
      // The provider tells its own dialogs from other modals by this class. Slightly
      // wider than md so the two columns breathe.
      className="vein-product-dialog sm:max-w-[520px]"
      bodyClassName="px-8 pt-7 pb-8"
      // !px-8 matches the body's inset; the footer's own padding is px-6.
      footerClassName="flex items-center justify-between gap-3 !px-8"
      footer={
        <>
          <p className="text-sm text-gray-500">
            Have a thought?{' '}
            <Button variant="bare" onClick={onFeedback} className="font-medium text-vein-red-600 underline underline-offset-4 rounded-sm">
              Leave feedback
            </Button>
          </p>
          <Button onClick={onClose}>Got it</Button>
        </>
      }
    >
      {latest ? (
        <ReleaseNotes release={latest} />
      ) : (
        <EmptyState icon={<SparklesIcon className="w-6 h-6" strokeWidth={2} aria-hidden="true" />} title="You’re up to date" message="Future product updates will appear here." />
      )}
    </Modal>
  );
}
